import outdatedBrowserRework from 'outdated-browser-rework';

function oldbrowser() {
  if (typeof window !== 'undefined') return;

  outdatedBrowserRework({
    browserSupport: {
      Chrome: 103, // Includes Chrome for mobile devices
      Edge: 103,
      Safari: 14,
      'Mobile Safari': 14,
      Firefox: 112,
      Opera: 97,
      // You could specify a version here if you still support IE in 2017.
      // You could also instead seriously consider what you're doing with your time and budget
      IE: false,
      'Opera Mini': false,
    },
    requireChromeOnAndroid: false,
    isUnknownBrowserOK: true,
    requiredCssProperty: 'flex',
    messages: {
      en: {
        outOfDate: 'Your browser is out of date!',
        unsupported: 'Your browser is not supported!',
        update: {
          web: 'Update your browser to view this website correctly. ',
          googlePlay: 'Please install Chrome from Google Play',
          appStore: 'Please update iOS from the Settings App',
        },
        // You can set the URL to null if you do not want a clickable link or provide
        // your own markup in the `update.web` message.
        url: 'http://outdatedbrowser.com/',
        callToAction: 'Update my browser now',
        close: 'Close',
      },
    },
  });
}

export default oldbrowser;
